var map = {
	"./landlord_1.png": 673,
	"./landlord_10.png": 645,
	"./landlord_11.png": 20,
	"./landlord_12.png": 703,
	"./landlord_13.png": 918,
	"./landlord_14.png": 481,
	"./landlord_15.png": 88,
	"./landlord_16.png": 419,
	"./landlord_17.png": 996,
	"./landlord_18.png": 469,
	"./landlord_19.png": 228,
	"./landlord_2.png": 242,
	"./landlord_20.png": 80,
	"./landlord_21.png": 329,
	"./landlord_22.png": 861,
	"./landlord_23.png": 723,
	"./landlord_24.png": 460,
	"./landlord_3.png": 155,
	"./landlord_4.png": 756,
	"./landlord_5.png": 669,
	"./landlord_6.png": 190,
	"./landlord_7.png": 335,
	"./landlord_8.png": 976,
	"./landlord_9.png": 225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;